import { useMemo } from 'react'
import useFirestoreUser from '../../../hooks/useFirestoreUser'
import useReport from '../../../hooks/useReport'
import useStagesCount from '../../../hooks/useStagesCount'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import useIsHomeLoading from '../../../hooks/useIsHomeLoading'
import { getDietStatus } from '../../../utils/dietStatus'

interface DashboardData {
  user: ReturnType<typeof useFirestoreUser>
  report: ReturnType<typeof useReport>
  stagesCount: number
  dietStatus: string
  purpleBubbleContent: ReturnType<typeof usePurpleBubblesText>
  isLoading: boolean
}

export const useDashboardData = (
  month: string,
  isReady: boolean
): DashboardData => {
  const user = useFirestoreUser()
  const report = useReport(month)
  const stagesCount = useStagesCount()
  const purpleBubbleContent = usePurpleBubblesText('Dashboard')
  const isHomeLoading = useIsHomeLoading()

  const dashboardData = useMemo(() => {
    const dietStatus = getDietStatus(report)
    const isLoading = isHomeLoading || !isReady

    return {
      user,
      report,
      stagesCount,
      dietStatus,
      purpleBubbleContent,
      isLoading,
    }
  }, [user, report, stagesCount, purpleBubbleContent, isHomeLoading, isReady])

  return dashboardData
}
